/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState, useEffect } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
// import { getUserByToken, register } from '../core/_requests'
import { Link, useNavigate } from 'react-router-dom'
// import { toAbsoluteUrl } from '../../../../_4threal/helpers'
import { PasswordMeterComponent } from '../../../../_4threal/assets/ts/components'
import { useAuth } from '../core/Auth'
import { authSignup, authLogin } from '../../../../redux/action/auth'
import { useDispatch } from 'react-redux'
import { generatePopup } from '../../../../utils/popup'
// import { authLogin } from '../../../../redux/action/auth'
import { Button } from 'react-bootstrap'
import { getCards } from '../../../../redux/action/card'
import { auth } from '../../../../firebase'
import { GoogleAuthProvider, OAuthProvider, signInWithPopup } from 'firebase/auth'
import ReactGA from "react-ga4";
import { isFeatureEnabled } from '../../../../config'
import { getFunctions, httpsCallable } from 'firebase/functions'
// import { GoogleAuthProvider, signInWithPopup} from 'firebase/auth'

const initialValues = () => ({
  firstname: '',
  lastname:  '',
  email: '',
  password: '',
  changepassword: '',
  acceptTerms: false,
})


const registrationSchema = Yup.object().shape({
  firstname: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('First name is required'),
  email: Yup.string().email('Wrong email format').required('Email is required'),
  lastname: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Last name is required'),
  password: Yup.string()
    .required('Password is required')
    .min(8, 'Password must be at least 8 characters long'),
  changepassword: Yup.string()
    .required('Password confirmation is required')
    .oneOf([Yup.ref('password')], "Password and Confirm Password didn't match"),
  acceptTerms: Yup.boolean().required('You must accept the terms and conditions'),
})


export function Registration(props: any = {}) {
  const {betadata} = props
  const [loading, setLoading] = useState(false)
  const [passwordVisible, setPasswordVisible] = useState(false)
  // const { saveAuth, setCurrentUser } = useAuth() //omitted due to eslint warning
  const { saveAuth } = useAuth()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const environment = process.env.REACT_APP_ENVIRONMENT;
  const [affiliateId, setAffiliateId] = useState<string | null>(null)

  const viewicon = {
    top: '50% ',
    transform: 'translateY(-50%)',
    right: '10px',
  }

  const bgTransparent = { background: 'transparent' }

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: registrationSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      if (loading) return;
      setLoading(true)
      try {
        // Set affiliate metadata BEFORE creating the user account
        if (affiliateId) {
          try {
            const functions = getFunctions()
            const setAffiliateMetadataFn = httpsCallable(functions, 'setAffiliateMetadata')
            await setAffiliateMetadataFn({
              affiliateId,
              email: values.email
            })
            console.log('Affiliate metadata set for email signup:', values.email)
          } catch (error) {
            console.error('Error setting affiliate metadata:', error)
            // Don't fail registration if affiliate metadata fails
          }
        }

        const signupRes: any = await dispatch(
          authSignup({
            firstName: values.firstname,
            lastName: values.lastname,
            email: values.email,
            password: values.password,
            Terms: values.acceptTerms,
          })
        )
        
        console.log('res', signupRes)
        let uid = signupRes?.uid;
        if (uid) {
          localStorage.setItem('userId', uid);
          
          // Clean up affiliate ID from localStorage
          if (affiliateId) {
            localStorage.removeItem('affiliateId')
          }
          
          // Log the user in after successful registration
          dispatch(authLogin({
            email: values.email,
            password: values.password,
          })).then((loginRes: any) => {
                if (environment === 'production') {
                  ReactGA.gtag("event", "conversion", {
                    send_to: "AW-16851717275/lzeeCNiz4LwaEJuZw-M-"
                  });
                  
                  // Track Meta Pixel StartTrial event for new user signups
                  const win = window as any
                  if ('fbq' in win) {
                    win.fbq('track', 'StartTrial', {
                      value: '0.00',
                      currency: 'USD',
                      predicted_ltv: '0.00',
                    })
                  }
                }

                dispatch(getCards(50, 1, uid)).then((resp) => {
                  setLoading(false)
                  navigate("/dashboard")
                }).catch((error) => {
                  setLoading(false)
                  console.error('Error loading cards:', error)
                })
              }).catch((loginError) => {
                setLoading(false)
                console.error('Error logging in after registration:', loginError)
                // If login fails, still redirect but user will need to login manually
                navigate("/dashboard")
              })
        }
      } catch (error: any) {
        saveAuth(undefined)
        setStatus((error?.response?.data?.message || 'The registration details is incorrect').replace(/"/g, ''))
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  const handleGoogleSignIn = async () => {
    setLoading(true)
    const provider = new GoogleAuthProvider()
    const storedAffiliateId = localStorage.getItem('affiliateId')
    
    try {
      const result = await signInWithPopup(auth, provider)
      const user = result.user
      localStorage.setItem('userId', user.uid)
      
      // For social logins, set affiliate ID immediately after user creation
      if (storedAffiliateId) {
        try {
          const functions = getFunctions()
          const setAffiliateForUserFn = httpsCallable(functions, 'setAffiliateForUser')
          await setAffiliateForUserFn({
            affiliateId: storedAffiliateId,
            userId: user.uid
          })
          console.log('Affiliate ID linked via custom claim:', storedAffiliateId)
          localStorage.removeItem('affiliateId')
        } catch (error) {
          console.error('Error setting affiliate for user:', error)
        }
      }
      
      // Track conversion for production
      if (environment === 'production') {
        ReactGA.gtag("event", "conversion", {
          send_to: "AW-16851717275/lzeeCNiz4LwaEJuZw-M-"
        });
        
        const win = window as any
        if ('fbq' in win) {
          win.fbq('track', 'StartTrial', {
            value: '0.00',
            currency: 'USD',
            predicted_ltv: '0.00',
          })
        }
      }
      
      await dispatch(getCards(50, 1, user.uid)).then((resp) => {
        navigate("/dashboard")
      })
    } catch (error: any) {
      console.error('Error during Google sign-in', error)
      
      // Handle account linking errors - let Firebase handle this automatically
      if (error.code === 'auth/account-exists-with-different-credential') {
        // This should not happen with "Link accounts that use the same email" enabled
        // But if it does, inform the user they can sign in with either method
        console.log('Account exists with different credential:', error.email)
        generatePopup('info', 'Account linked successfully! You can now sign in with either method.')
      } else {
        generatePopup('error', 'Failed to sign up with Google. Please try again.')
      }
    }
    setLoading(false)
  }

  const handleAppleSignIn = async () => {
    setLoading(true)
    const provider = new OAuthProvider('apple.com')
    provider.addScope('email')
    provider.addScope('name')
    const storedAffiliateId = localStorage.getItem('affiliateId')
    
    try {
      const result = await signInWithPopup(auth, provider)
      const user = result.user
      localStorage.setItem('userId', user.uid)
      
      // For social logins, set affiliate ID immediately after user creation
      if (storedAffiliateId) {
        try {
          const functions = getFunctions()
          const setAffiliateForUserFn = httpsCallable(functions, 'setAffiliateForUser')
          await setAffiliateForUserFn({
            affiliateId: storedAffiliateId,
            userId: user.uid
          })
          console.log('Affiliate ID linked via custom claim:', storedAffiliateId)
          localStorage.removeItem('affiliateId')
        } catch (error) {
          console.error('Error setting affiliate for user:', error)
        }
      }
      
      // Track conversion for production
      if (environment === 'production') {
        ReactGA.gtag("event", "conversion", {
          send_to: "AW-16851717275/lzeeCNiz4LwaEJuZw-M-"
        });
        
        const win = window as any
        if ('fbq' in win) {
          win.fbq('track', 'StartTrial', {
            value: '0.00',
            currency: 'USD',
            predicted_ltv: '0.00',
          })
        }
      }
      
      await dispatch(getCards(50, 1, user.uid)).then((resp) => {
        navigate("/dashboard")
      })
    } catch (error: any) {
      console.error('Error during Apple sign-in', error)
      
      // Handle account linking errors - let Firebase handle this automatically
      if (error.code === 'auth/account-exists-with-different-credential') {
        // This should not happen with "Link accounts that use the same email" enabled
        // But if it does, inform the user they can sign in with either method
        console.log('Account exists with different credential:', error.email)
        generatePopup('info', 'Account linked successfully! You can now sign in with either method.')
      } else {
        generatePopup('error', 'Failed to sign up with Apple. Please try again.')
      }
    }
    setLoading(false)
  }

  useEffect(() => {
    PasswordMeterComponent.bootstrap()
    
    // Check for affiliate ID in localStorage
    const storedAffiliateId = localStorage.getItem('affiliateId')
    if (storedAffiliateId) {
      setAffiliateId(storedAffiliateId)
      console.log('Affiliate ID found for registration:', storedAffiliateId)
    }
  }, [])

  // Affiliate metadata is now set before user creation
  // The createUser trigger will automatically pick it up from pending_affiliate_metadata

  return (
    <>
      <div className="alert alert-warning mb-4 mx-5">
        <div className="d-flex align-items-center">
          <i className="fas fa-exclamation-triangle me-2"></i>
          <div>
            You're using the legacy signup flow.{' '}
            <button
              type="button"
              className="btn btn-link p-0 text-decoration-underline"
              onClick={() => navigate('/auth/registration')}
            >
              Try our improved experience →
            </button>
          </div>
        </div>
      </div>
      
      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework p-5'
        noValidate
        id='kt_login_signup_form'
        onSubmit={formik.handleSubmit}
      >
        <div className='text-start mb-11'>
        <h1 className='text-dark fw-bolder mb-3'>Get Started</h1>
        <p className='font-dark1'>Welcome to app.Skanteq.com — Let's create your account.</p>
      </div>
      {formik.status && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}

      <div className='row'>
        <div className='col-12 col-md-6 fv-row mb-8'>
          <label className='form-label fw-semibold font-dark1 fs-6'>First name</label>
          <input
            placeholder='First name'
            type='text'
            style={bgTransparent}
            autoComplete='off'
            {...formik.getFieldProps('firstname')}
            className={clsx(
              'form-control bg-transparent',
              {
                'border-red': formik.touched.firstname && formik.errors.firstname,
              },
              {
                'border-primary': formik.touched.firstname && !formik.errors.firstname,
              }
            )}
            onChange={(e) => {
              const inputValue = e.target.value
              if (!inputValue.match(/^[A-Za-z]+$/)) {
                e.target.value = inputValue.replace(/[^A-Za-z]/g, '')
              }
              formik.handleChange(e)
            }}
          />
          {formik.touched.firstname && formik.errors.firstname && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{typeof formik.errors.firstname === 'string' ? formik.errors.firstname : ''}</span>
              </div>
            </div>
          )}
        </div>
        <div className='col-12 col-md-6 fv-row mb-8'>
          <label className='form-label fw-semibold font-dark1 fs-6'>Last name</label>
          <input
            placeholder='Last name'
            type='text'
            style={bgTransparent}
            autoComplete='off'
            {...formik.getFieldProps('lastname')}
            className={clsx(
              'form-control bg-transparent',
              {
                'border-red': formik.touched.lastname && formik.errors.lastname,
              },
              {
                'border-primary': formik.touched.lastname && !formik.errors.lastname,
              }
            )}
            onChange={(e) => {
              const inputValue = e.target.value
              if (!inputValue.match(/^[A-Za-z]+$/)) {
                e.target.value = inputValue.replace(/[^A-Za-z]/g, '')
              }
              formik.handleChange(e)
            }}
          />
          {formik.touched.lastname && formik.errors.lastname && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{typeof formik.errors.lastname === 'string' ? formik.errors.lastname : ''}</span>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className='fv-row mb-8'>
        <label className='form-label fw-semibold font-dark1 fs-6'>Email address </label>
        <input
          placeholder='Email'
          style={bgTransparent}
          type='email'
          autoComplete='off'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control bg-transparent',
            { 'border-red': formik.touched.email && formik.errors.email },
            {
              'border-primary': formik.touched.email && !formik.errors.email,
            }
          )}
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{typeof formik.errors.email === 'string' ? formik.errors.email : ''}</span>
            </div>
          </div>
        )}
      </div>
      <div className='fv-row mb-8' data-kt-password-meter='true'>
        <div className='mb-1'>
          <label className='form-label fw-semibold font-dark1 fs-6'>Password</label>
          <div className='position-relative mb-3'>
            <input
              type='password'
              style={bgTransparent}
              placeholder='Password'
              autoComplete='off'
              {...formik.getFieldProps('password')}
              className={clsx(
                'form-control bg-transparent',
                {
                  'border-red font-red': formik.touched.password && formik.errors.password,
                },
                {
                  'border-primary': formik.touched.password && !formik.errors.password,
                }
              )}
            />
            <div
              style={{ top: '50%', right: '10px', width: '50px', transform: 'translateY(-50%)' }}
              className='d-flex align-items-center mb-3 position-absolute '
              data-kt-password-meter-control='highlight'
            >
              <div style={{ flexGrow: '0.2' }} className='bg-secondary  rounded h-20px me-2'></div>
              <div style={{ flexGrow: '0.2' }} className='bg-secondary  rounded h-20px me-2'></div>
              <div style={{ flexGrow: '0.2' }} className='bg-secondary  rounded h-20px me-2'></div>
              <div style={{ flexGrow: '0.2' }} className='bg-secondary  rounded h-20px '></div>
            </div>
          </div>
          {formik.touched.password && formik.errors.password && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.password}</span>
              </div>
            </div>
          )}
        </div>

        <div className='text-muted font-gray1'>
          Use 8 or more characters with a mix of letters, numbers & symbols
        </div>
      </div>
      <div className='fv-row mb-5'>
        <label className='form-label fw-semibold text-dark fs-6'>Confirm Password</label>
        <div className='position-relative'>
          <input
            type={passwordVisible ? 'text' : 'password'}
            style={bgTransparent}
            placeholder='Password confirmation'
            autoComplete='off'
            {...formik.getFieldProps('changepassword')}
            className={clsx(
              'form-control bg-transparent',
              {
                'border-red font-red':
                  formik.touched.changepassword && formik.errors.changepassword,
              },
              {
                'border-primary': formik.touched.changepassword && !formik.errors.changepassword,
              }
            )}
          />

          {passwordVisible ? (
            <i
              style={viewicon}
              onClick={() => setPasswordVisible(!passwordVisible)}
              className='bi bi-eye-slash fs-5 position-absolute'
            ></i>
          ) : (
            <i
              style={viewicon}
              onClick={() => setPasswordVisible(!passwordVisible)}
              className='bi bi-eye fs-5 position-absolute'
            ></i>
          )}
        </div>
        {formik.touched.changepassword && formik.errors.changepassword && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.changepassword}</span>
            </div>
          </div>
        )}
      </div>
      <div className='fv-row mb-8'>
        <label className='form-check form-check-inline' htmlFor='kt_login_toc_agree'>
          <input
            className='form-check-input '
            type='checkbox'
            id='kt_login_toc_agree'
            {...formik.getFieldProps('acceptTerms')}
          />

          <span className='font-dark1'>I agree to the <a href='https://skanteq.com/terms-of-service/' target='_blank' className='link-primary'>terms and conditions</a></span>
        </label>
      </div>
      {/* <div className='fv-row mb-8'>
        <label className='form-check form-check-inline' htmlFor='kt_login_toc_agree'>
          <input
            className='form-check-input'
            type='checkbox'
            id='kt_login_toc_agree'
            {...formik.getFieldProps('acceptTerms')}
          />
          <span>
            I Accept the{' '}
            <a
              href='#'
              target='_blank'
              className='ms-1 link-primary'
            >
              Terms
            </a>
            .
          </span>
          {formik.touched.acceptTerms && formik.errors.acceptTerms && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.acceptTerms}</span>
              </div>
            </div>
          )}
        </label>
      </div> */}
      <div className='row align-items-center'>
        <div className='col-12'>
          <Button
            style={{ cursor: loading ? 'not-allowed' : 'pointer' }}
            type='submit'
            id='kt_sign_up_submit'
            className='btn btn-lg btn-primary w-100 mb-3'
            disabled={loading || formik.isSubmitting || !formik.isValid || !formik.values.acceptTerms}
          >
            {!loading && <span className='indicator-label'>Create an account</span>}
            {loading && (
              <span className='indicator-progress' style={{ display: 'block' }}>
                Creating account...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </Button>

          <div className='separator separator-content my-4'>
            <span className='w-125px text-gray-500 fw-semibold fs-7'>Or </span>
          </div>

          <Button
            type='button'
            className='btn btn-flex flex-center btn-light w-100 mb-3 border border-dark text-dark'
            onClick={handleGoogleSignIn}
            disabled={loading}
            style={{ backgroundColor: 'white' }}
          >
            <img alt='Logo' src='/media/icons/duotune/general/google.svg' className='h-20px me-3' />
            Sign up with Google
          </Button>

          <Button
            type='button'
            className='btn btn-flex flex-center btn-light w-100 mb-3 border border-dark text-dark'
            onClick={handleAppleSignIn}
            disabled={loading}
            style={{ backgroundColor: 'white' }}
          >
            <img alt='Logo' src='/media/icons/duotune/general/apple.svg' className='h-20px me-3' />
            Sign up with Apple
          </Button>

          <div className='font-dark1 text-center fs-6'>
            Have an account?{' '}
            <Link to='/auth/login' className='text-decoration-underline font-dark1 fw-semibold'>
              Login
            </Link>
          </div>
        </div>
      </div>
    </form>
    </>
  )
}
